export var ArcGisBayColumn;
(function (ArcGisBayColumn) {
    ArcGisBayColumn["Id"] = "OBJECTID";
    ArcGisBayColumn["TradingSiteDescription"] = "TradingSiteDescription";
    ArcGisBayColumn["TradingSiteStatus"] = "TradingSiteStatus";
    ArcGisBayColumn["TradingSiteTown"] = "TradingSiteTown";
    ArcGisBayColumn["SgCode"] = "SgCode";
    ArcGisBayColumn["Size"] = "Size";
    ArcGisBayColumn["Status"] = "Status";
})(ArcGisBayColumn || (ArcGisBayColumn = {}));
